<script lang="ts">
  import { Col, FormGroup, Input, Label, Row } from "sveltestrap";
  import {
    Number,
    Password,
    Placeholder,
    SimpleInput,
    Telephone,
  } from "../../../../utils/Constant/Constant";
</script>

<FormGroup >
  <Row>
    <Col sm="3">
      <Label class="col-form-label">{SimpleInput}</Label>
    </Col>
    <Col sm="9">
      <Input type="text" />
    </Col>
  </Row>
</FormGroup>
<FormGroup>
  <Row>
    <Col sm="3">
      <Label class="col-form-label">{Placeholder}</Label>
    </Col>
    <Col sm="9">
      <Input type="text" placeholder="Type your title in Placeholder" />
    </Col>
  </Row>
</FormGroup>
<FormGroup >
  <Row>
    <Col sm="3">
      <Label class="col-form-label">{Password}</Label>
    </Col>
  <Col sm="9">
    <Input type="password" placeholder="Password input" />
  </Col>
  </Row>
</FormGroup>
<FormGroup>
  <Row>
    <Col sm="3">
      <Label class="col-form-label">{Number}</Label>
    </Col>
    <Col sm="9">
      <Input class="digits" type="number" placeholder="Number" />
    </Col>
  </Row>
</FormGroup>
<FormGroup>
  <Row>
    <Col sm="3">
      <Label class="col-form-label">{Telephone}</Label>
    </Col>
    <Col sm="9">
      <Input class="m-input digits" type="number" value="91-(999)-999-999" />
    </Col>
  </Row>
</FormGroup>
